/** HTTP links in plain social text. Indices preserve all original whitespace. */
export function socialLinks(text:string):Array<{url:string;start:number;end:number}>{
 const links:Array<{url:string;start:number;end:number}>=[];
 for(const match of text.matchAll(/https?:\/\/[^\s<>"']+/gi)){
  let url=match[0].replace(/[.,!?:;]+$/,'');
  // Keep balanced URL parentheses, but exclude prose wrapping the URL.
  for(const [open,close] of [['(',')'],['[',']'],['{','}']]){
   while(url.endsWith(close)&&url.split(close).length>url.split(open).length)url=url.slice(0,-1);
  }
  url=url.replace(/[.,!?:;]+$/,'');
  try{const parsed=new URL(url);if(!parsed.hostname||parsed.username||parsed.password)continue}catch{continue}
  links.push({url,start:match.index!,end:match.index!+url.length});
 }
 return links;
}

/** Legacy drafts may carry a separate attachment URL. Never duplicate an inline URL. */
export function withLegacyLink(text:string,link?:string|null):string{
 if(!link)return text;
 const canonical=(value:string)=>{try{return new URL(value).href}catch{return value}};
 if(socialLinks(text).some(found=>canonical(found.url)===canonical(link)))return text;
 return [text,link].filter(Boolean).join('\n\n');
}

/** Existing frozen link-only revisions keep their original commentary semantics. */
export function publicationCommentary(text:string,link:string|undefined,images:boolean):string{
 return images?withLegacyLink(text,link):text;
}
